<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        :value="value"
        :value-key="PayloadSingleId"
        :include-key="includeKey"
        :value-type="valueType"
        :id-vista="idVista"
        :selected-field="selectedField"
        :in-edit-field="inEditField"
        :expand-field="expandField"
        :single="single"
        :select-on-row-click="selectOnRowClick"
        :edit-on-row-click="editOnRowClick"
        :expand-on-row-click="expandOnRowClick"
        :is-row-editable="isRowEditable"
        :update-columns="updateColumns"
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        @actionclick="openPath"
        @datastatechange='dataStateChange'
        v-on="$listeners">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :baseDropDownVisible="getAccionesPosibles.length > 0"
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" />
                {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <Dialog
        :title="dialogTitle"
        :visible.sync="showModal"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ dialogMesage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </Dialog>
      <component
        :is="FilterPanel"
        :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" 
        :vuexnamespace="vuexnamespace"
        />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import { Dialog } from 'element-ui'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'

import getValueKeyOrDefault from '@/services/functions/getValueKeyOrDefault'
import { isNil } from 'lodash'

export default {
  name: 'vista-papelera-generic',
  components: {
    ListLayout,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    Dialog,
  },
  props: {
    // #region KendoGridComponent properties
    value: {
      required: true
    },
    valueType: String,
    includeKey: [Array, String, Number],
    selectedField: {
      type: String,
      default: 'selected'
    },
    inEditField: {
      type: String,
      default: 'inEdit'
    },
    expandField: {
      type: String,
      default: 'expanded'
    },
    loading: {
      type: Boolean,
      default: false
    },
    single: {
      type: Boolean,
      default: false
    },
    selectOnRowClick: {
      type: Boolean,
      default: false
    },
    editOnRowClick: {
      type: Boolean,
      default: false
    },
    expandOnRowClick: {
      type: Boolean,
      default: false
    },
    isRowEditable: {
      type: Function,
      default: dataItem => true
    },
    updateColumns: {
      type: Boolean,
      default: false
    },
    // #endregion
    doRestore: {
      type: Function,
      required: true,
    },
    doDelete: {
      type: Function,
      required: true,
    },
    getParams: {
      type: Function,
      default: data => ({})
    },
    getParamsMultiple: {
      type: Function,
      default: data => ({})
    },
    FilterPanel: null,
    RouteName: String,
    dialogTitle: String,
    dialogMesage: String,
    ExcelName: String,
    getExcel: {
      type: Function,
      required: true,
    },
    idVista: Number,
    HeaderTitle: String,
    vuexnamespace: String,
    PayloadSingleId: { 
      type: [Array, String], 
      required: true,
      validator: value => (Array.isArray(value) ? value : [value]).every(x => typeof x === 'string') && value.length
    },
    PayloadMultipleId: String,
    PayloadMultipleType: {
      type: String,
      default: 'Object',
      validator: value => ['Array', 'Object'].includes(value)
    },
    getPag: {
      type: Function,
      default: data => ({})
    }
  },
  data: function () {
    return {
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: this.HeaderTitle,
        icon: 'trash',
        breadcrumb: null,
        url: null
      },
      hasClientFilterData: false,
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selectedAction: null,
      listaAcciones: [
        { IdAccion: 900, Descripcion: i18n.t('trash.delete') },
        { IdAccion: 901, Descripcion: i18n.t('trash.restore') }
      ],
    }
  },
  computed: {
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.value.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.data?.length || 0
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    selected: function () {
      if (this.single) {
        return !isNil(this.value) ? [this.value] : []
      }
      return this.value
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    selectIcon: function (action) {
      return (action) =>
        action === 900 ? 'trash' 
          : 'enter'
    },
    getAccionesPosibles () {
      return this.listaAcciones
    },
  },
  watch: {
    $route (to, from) {
      this.updateOnRouteChange(to, from)
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
  },
  created: async function () {
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    }
    this.data = await this.applyFilters()
  },
  methods: {
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id } }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    openPath: function (event) {
      const params = Array.isArray(this.PayloadSingleId)
        ? this.preserve(this.PayloadSingleId, event.dataItem)
        : { id: getValueKeyOrDefault(event.dataItem, this.PayloadSingleId, { asObject: true }) }
      this.$router.push({ name: 'trash/'+ this.RouteName +'/details', params })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = { ...this.getParams(data), borrados: true }

      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
        const payload = { order: objOrder.order, grupos: objColumnas, ...this.getParamsMultiple(data) }
        if (this.hasSelected) {
          var mapper = x => getValueKeyOrDefault(x, this.PayloadSingleId, { asObject: true })
          const selectedIDs = this.selected.map(mapper)
          payload.listaIDs = selectedIDs
        }
        const response = await this.getExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = this.ExcelName
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    updateOnRouteChange: async function (to, from) {
      await this.applyFilters()
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const params = { ...this.getParams(data), borrados: true }

      const objOrder = { ...this.getParamsMultiple(data), ...this.getObjOrderMixin(this.kendo.group, this.kendo.sort) }
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        console.log('CustomLog: error', error)
        this.doFeedback()
      }

      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.Respuesta || res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await this.getPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    unselect: function () {
      this.$emit('input', [])
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 900) { // borrar
        this.deleteImpuesto()
      } else if (this.selectedAction.IdAccion === 901) { // recuperar
        this.restoreImpuesto()
      } else {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
      }
    },
    restoreImpuesto: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const data = []
        const payload = this.PayloadMultipleType === 'Array' ? data : {
          [this.PayloadMultipleId]: data
        }
        for (const element of this.selected) {
          data.push(getValueKeyOrDefault(element, this.PayloadSingleId, { asObject: true }))
        }
        const response = await this.doRestore(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.unselect()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    deleteImpuesto: async function () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const data = []
        const payload = this.PayloadMultipleType === 'Array' ? data : {
          [this.PayloadMultipleId]: data
        }
        for (const element of this.selected) {
          data.push(getValueKeyOrDefault(element, this.PayloadSingleId, { asObject: true }))
        }
        const response = await this.doDelete(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.unselect()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>
